export type ColumnDisplayEntry = 'nowrap' | 'empty-only' | { clamp: 1 | 2 | 3 };
export type ColumnDisplay = ColumnDisplayEntry | ColumnDisplayEntry[];
export const COLUMN_DISPLAY_CONFIG: Record<string, ColumnDisplay> = {
  date: 'nowrap',
  reference: 'nowrap',
  ref_no: 'nowrap',
  invoice_no: 'nowrap',
  receipt_no: 'nowrap',
  voucher_no: 'nowrap',
  bill_no: 'nowrap',
  code: 'nowrap',
  status: 'nowrap',
  risk: 'nowrap',
  severity: 'nowrap',
  priority: 'nowrap',
  job: 'nowrap',
  amount: 'nowrap',
  total: 'nowrap',
  total_amount: 'nowrap',
  balance: 'nowrap',
  paid: 'nowrap',
  paid_amount: 'nowrap',
  due: 'nowrap',
  due_amount: 'nowrap',
  debit: 'nowrap',
  credit: 'nowrap',
  price: 'nowrap',
  workorder: 'nowrap',
  budget: 'empty-only',
  sub_category: 'empty-only',
  reported_by: 'empty-only',
  suggestion: 'empty-only',
  net_amount: 'nowrap',
  gross_amount: 'nowrap',
  vat: 'nowrap',
  vat_amount: 'nowrap',
  tax: 'nowrap',
  tax_amount: 'nowrap',

  // ── clamp: 2 lines — short text columns ──────────────────────────────────
  name: { clamp: 2 },
  full_name: { clamp: 2 },
  title: { clamp: 2 },
  subject: { clamp: 2 },
  company_name: { clamp: 2 },
  location: { clamp: 2 },
  email: { clamp: 2 },
  type: { clamp: 2 },
  category: { clamp: 2 },
  primary_email: { clamp: 2 },
  client_name: { clamp: 2 },
  client_email: { clamp: 2 },
  tenant_english_name: { clamp: 2 },
  unit: { clamp: 2 },
  unit_no: { clamp: 2 },
  unitCustomer: { clamp: 2 },
  vendor_ref: { clamp: 2 },

  // ── clamp: 3 lines — long-form text ──────────────────────────────────────
  description: { clamp: 3 },
  note: { clamp: 3 },
  memo: { clamp: 3 },
  comment: { clamp: 3 },
  comments: { clamp: 3 },
  remarks: { clamp: 3 },
  address: { clamp: 3 },
  log: { clamp: 3 },

  // ── clamp: 1 line — single-line text columns ─────────────────────────────
  position: { clamp: 1 },
  mobile: { clamp: 1 },
  phone: { clamp: 1 },
  asset_code: { clamp: 1 },
  reminder_cycle: { clamp: 1 },
};

/**
 * Suffix patterns that map to `'nowrap'` implicitly.
 * Covers unbounded names like `created_at`, `login_at`, `due_date`, `scheduled_date`, etc.
 */
export const NOWRAP_PATTERNS: RegExp[] = [/_at$/, /_date$/];
